import { useContext } from "react";
import { EditingContextContext } from "../state/contexts";

function useEditingContext() {
  return useContext(EditingContextContext);
}

export default useEditingContext;
